import { createContext } from 'react';
import type { Session, User } from '@supabase/supabase-js';

export interface AuthContextValue {
  /** Current Supabase session, or null when signed out. */
  session: Session | null;
  user: User | null;
  /** True until the initial session lookup resolves. */
  isLoading: boolean;
  /**
   * `nextPath` rides on the confirm link (`/login?next=...`) so the user lands
   * back where they started once confirmed. Supabase's redirect allow-list
   * must accept the query.
   */
  signUp: (email: string, password: string, nextPath?: string) => Promise<void>;
  signIn: (email: string, password: string) => Promise<void>;
  requestPasswordReset: (email: string) => Promise<void>;
  updatePassword: (password: string) => Promise<void>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
